import React from 'react'
import { NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'




const routes = [
    {
      id:1,
      name: "Home",
      icon: <i className="fa-solid fa-house-user"></i>
    },
    {
        id:2,
        name:"Short",
        icon: <i className="fa-solid fa-circle-play"></i>
    },
    {
        id:3,
        name:"Subscription",
        icon :<i className="fa-solid fa-film"></i>
      
    },
    {
        id:4,
        name:"Library",
        icon:<i className="fa-solid fa-video"></i>
      
    },
    {
        id:5,
        name:"History",
        icon:<i className="fa-solid fa-clock-rotate-left"></i>
      
    },
    {
        id:6,
        name:"Your Videos",
        icon:<i className="fa-brands fa-square-vimeo"></i>
      
    },
    {
        id:7,
        name:"Watch Later",
        icon:<i className="fa-solid fa-clock"></i>
      
    },
    
 
 
   
  
  
  ]
const ReuseSidebar = (  {sidebar} ) => {

  return (
    <>
      
         <section className='routes overflow-scroll' style={{height:"100vh"}}>
            {
              routes && routes.map((route) => {
                return (
                  <button  className="link btn  hstack " key={route.id} >
                    <div className="icon fs-4">{route.icon}</div>
                    <div className="icon d-block d-sm-none">{route.name}</div>
                    {
                        sidebar && <motion.div initial={{
                            opacity :0, transition:{duration:0.8}}} animate={{opacity:1,transition:{
                                duration:0.8
                            }}}>{
                                route.name
                            }

                        </motion.div>
                    }

                  
                  
                  </button>
                )
              })
            }
          </section> 
    </>
  )
}

export default ReuseSidebar
